import { render, staticRenderFns } from "./case-overview-component.vue?vue&type=template&id=6c5e724e&scoped=true"
import script from "./case-overview-component.vue?vue&type=script&lang=ts"
export * from "./case-overview-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e724e",
  null
  
)

export default component.exports